export const HEIGHT_PRESCRIPTION_VALUES = 363
export const HEIGHT_PRESCRIPTION_ITEM = 345
